<template>
  <v-row justify="center">
    <v-dialog v-model="dialogVisible" persistent max-width="600">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.stop="closeDialog()">
              <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{formData.stall_title}} Blocked Categories</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
          </v-toolbar-items>
        </v-toolbar>
        <v-alert
          v-model="alert.show"
          :dismissible="alert.dismissible"
          :type="alert.type"
          transition="fade-transition"
          class="ma-4"
        >
          {{ alert.text }}
        </v-alert>
        <v-form
          ref="form"
          v-model="form"
          class="px-4 pt-2"
        >
          <v-select
            v-model="formData.market_date_data.blocked_categories"
            :items="this.$store.state.categories"
            item-text="name"
            item-value="id"
            chips
            label="Blocked categories in this stall"
            multiple
            class="mt-5"
            hint="Stall cannot be booked (for this week) by stallholders if they belong to one of these categories"
            persistent-hint
          ></v-select>

        </v-form>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
              color="primary darken-1"
              text
              @click.stop="submitForm()"
              :disabled="isSaveBtnDisabled"
              :loading="isSaveBtnLoading"
          >
              Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="isSaveBtnLoading" z-index="1000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-row>
</template>
<script>

import axios from 'axios';
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    dialog: '',
    formData : {
       market_date_data: {
           blocked_categories: []
       }
    },
    isSaveBtnLoading: false,
    isCloseBtnDisabled: false,
    isSaveBtnDisabled: false,
    alert: {
      show: false,
      text: '',
      type: 'success',
      dismissible: true,
    },
    form: false,
    rules: {
      password: v => (v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) ||
        'Password must contain an upper case letter, a numeric character, and a special character',
      required: v => !!v || 'This field is required',
      email: v =>  /.+@.+/.test(v) || 'Please enter a valid email',
      maxLength: (len, v) => (v || '').length <= len || `Invalid character length, maximum ${len}`
    },
    alert: {
      show: false,
      text: '',
      type: 'info',
      dismissible: true,
    },
    setupTimeMenu: false,
    stallholderFilter: (item, queryText, itemText) => {
      let searchString = `${item.stall_name} ${item.first_name} ${item.last_name} ${item.email}`
      return searchString.toLowerCase().indexOf(queryText.toLowerCase()) > -1
    }
  }),
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
      required: false,
    },
    selectedId : {
      required: true,
    },
  },
  watch: {
    dialogVisible(newData, oldData) {
        if(newData) {
          this.formData = Object.assign({}, this.getStallById(this.selectedId));

          if(!this.formData.market_date_data || !this.formData.market_date_data.blocked_categories) {
            this.formData.market_date_data = {
              blocked_categories: []
            }
          }else{
            this.formData.market_date_data = Object.assign({}, this.formData.market_date_data); //unlink otherwise its link to the store stall data
          }
        }
    },
  },
  methods: {
    closeDialog(){
      this.$emit('close');
      this.formdata = {};
      this.isSaveBtnLoading = false;
      this.resetAlert();
    },
    submitForm(){

      this.resetAlert();
       
      if(this.$refs.form.validate())
        this.updateStall();

    },
    updateStall(){
      this.savingDialog = true;
      let self = this;
      this.isSaveBtnLoading = true;
      
      let isUpdatingId = ''

      if(this.formData.id!==0)
        isUpdatingId=this.formData.id;

      if(!this.formData.stallholder)
        this.formData.stallholder=''; // otherwise its undefined any doesnt get posted

      if(this.formData.market_date_data){
        this.formData.market_data={};
        this.formData.market_data[this.$store.state.selectedMarketDate] = this.formData.market_date_data;
      }   

      axios({
            method: 'POST',
            url: `/wisdom-markets/v1/stalls/${isUpdatingId}`,
            headers: {
               'Authorization': `Bearer ${this.$store.state.accessToken}`,
            }, 
            data: this.formData
        })
        .then(response => {
            console.log("saved", response);
            this.isSaveBtnLoading = false;
            this.savingDialog = false;
            self.showAlert('success', 'Saved!');
            this.$store.commit('updateStall', response.data);
        })
        .catch(function (error) {
            console.log("error saving", error);
            self.isSaveBtnLoading = false;
            self.savingDialog = false;
            self.showAlert('error', 'Error!');
        });

    },
    showAlert(type, text){
      this.alert.show = true;
      this.alert.text = text
      this.alert.type = type;
    },
    resetAlert() { //and reset
      this.alert = {
        show: false,
        text: '',
        type: 'info',
        dismissible: true,
      }
    },
  },
  computed: {
      //
      isDialogVisible(){
          if(this.dialog != this.dialogVisible) {
              return this.dialogVisible
          }else{
              return this.dialog
          }
      },
      ...mapGetters([
        'getStallById',
        'getStallholderColor'
      ])
  },
  mounted() {
      //this.dialog = this.dialogVisible;
     
  }
}
</script>